import { Map, List } from 'immutable';
import { without } from '../helpers/Immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

import StoredPaymentCard from '../records/customer/StoredPaymentCard';

class PaymentCardStore extends BaseStore {

    getInitialState () {
        const cards = new List();
        return new Map({ cards });
    }

    getKeyGoCard () {
        const cards = this.state.get('cards');
        return cards.find((card) => card.isKeyGoCard && card.cardToken) || new StoredPaymentCard();
    }

    hasCards () {
        return !this.state.get('cards').isEmpty();
    }

    handleCardsLoaded ({ cards }) {
        this.setState(this.state.set('cards', cards));
    }

    handleCardDeleted ({ deleted }) {
        const cards = without(this.state.get('cards'), deleted);
        this.setState(this.state.set('cards', cards));
    }

    getActionHandlers () {
        return {
            [ ActionTypes.CUSTOMER_PAYMENTCARDS_LOADED ]: this.handleCardsLoaded,
            [ ActionTypes.CUSTOMER_PAYMENTCARD_DELETED ]: this.handleCardDeleted,
            [ ActionTypes.LOGGED_OUT ]: this.resetState
        };
    }

}

export default new PaymentCardStore();



// WEBPACK FOOTER //
// ./src/stores/PaymentCardStore.js